/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';
import { getValueFromRefList } from '../../../../main/reducers/static/states/referenceLists/reducer';

export function restructureUserRatingStatusesModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    pointsFrom: lc.get(data, 'points_from'),
    pointsTo: lc.get(data, 'points_to'),
    rating: lc.get(data, 'rating'),
    incomeRef1Lvl: lc.get(data, 'income_ref_1_lvl'),
    incomeRef2Lvl: lc.get(data, 'income_ref_2_lvl'),
    addFundsFef1Lvl: lc.get(data, 'add_funds_ref_1_lvl'),
    addFundsFef2Lvl: lc.get(data, 'add_funds_ref_2_lvl'),
    commentPermission: lc.get(data, 'comment_permission'),
    payoutDelayDays: lc.get(data, 'payout_delay_days'),
    payoutDelayDaysDesc: lc.get(data, 'payout_delay_days_desc'),
    commentPermissionYesOrNo: getValueFromRefList(
      state,
      'yesOrNo',
      lc.get(data, 'comment_permission')
    ),
    updatedAt: lc.get(data, 'updated_at')
  };
}

export function restructureRatingPointModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    pointsTypeId: lc.get(data, 'points_type_id'),
    pointsTypeTitle: lc.get(data, 'points_type.title'),
    pointsTypeDesc: lc.get(data, 'points_type.desc'),
    points: lc.get(data, 'points'),
    comment: lc.get(data, 'comment'),
    userId: lc.get(data, 'user_id'),
    createdAt: lc.get(data, 'created_at'),
    updatedAt: lc.get(data, 'updated_at')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userRating/services/UserRatingService/restructuring/index.js